export default __webpack_public_path__ + "static/media/laser.05a3dca8.jpg";